import { IconButton as RadixIconButton, } from '@radix-ui/themes';
import { withMappingProps } from '../../utils/radix.js';
export const IconButton = withMappingProps(RadixIconButton);
//# sourceMappingURL=icon-button.js.map